import axiosInstance from "./axiosInstance";

const ContentAPI = {
  sendContactMessage: async (values) => {
    const response = await axiosInstance.post(
      "/front/contacts",
      values
    );
    return response.data;
  },
    NewsLetterMessage: async (values) => {
    const response = await axiosInstance.post(
      "/front/newsletter-emails",
      values
    );
    return response.data;
  },
    sendJobregister: async (values) => {
    const response = await axiosInstance.post(
      "/front/Job-register",
      values
    );
    return response.data;
  },
  getSettingData: async() => {
    const response = await axiosInstance.get("/front/setting");
    return response.data;
  },
};

export default ContentAPI;
